import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AppcuesService } from './appcues.service';
import { AppcuesOnboardingService } from './ng/service';
import { AppcuesOnboardingObserver } from './ng/observer.service';
import { AppcuesOnboardingRouteObserver } from './ng/route-observer.service';

@NgModule({
    declarations: [],
    imports: [ CommonModule ],
    exports: [],
    providers: [
        AppcuesService,
        AppcuesOnboardingRouteObserver,
        AppcuesOnboardingService,
        AppcuesOnboardingObserver,
    ],
})
export class AppcuesModule {}
